<script>
import replaceBarcodeDialog from "@/views/dialogCommon/replaceBarcodeDialog.vue";
import request from "@/router/axios";
import api from "../../api/projectApi";
import { mapGetters } from "vuex";
export default {
  extends: replaceBarcodeDialog,
  computed: {
    ...mapGetters("historicalWorkOrder", ["historical_workorder_form_data"]),
  },
  methods: {
    getData() {
      //获取对应的工单信息(获取state存储的工单信息)
      this.formData = this.historical_workorder_form_data;
      if (
        this.formData.soOrderLineDTOList &&
        this.formData.soOrderLineDTOList.length > 0
      ) {
        if (
          this.formData.soOrderLineDTOList[0].bigCategoryName &&
          this.formData.soOrderLineDTOList[0].bigCategoryName == "集成烹饪中心"
        ) {
          this.showBarcode2 = true;
        } else {
          this.showBarcode2 = false;
        }
      } else {
        this.showBarcode2 = false;
      }
    },
    replaceBarcode() {
      this.$mask.open();
      request({
        url: api.soOrderHistory.replaceBarcodeUrl,
        method: "post",
        data: this.formData,
        isLoading: true,
        modalStrictly: true,
      }).then((response) => {
        if (response.data.type == "success") {
          this.$message({ message: response.data.content, type: "success" });
          this.drawer = false;
          clearTimeout(this.timer);
          this.$emit("doReplaceBarcodeCheck", 1);
        } else {
          this.$message({ message: response.data.content, type: "warning" });
        }
      });
      this.$mask.close();
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
